/**
 * Created by Daniela on 30/01/2017.
 */
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { BombaNavigationService } from "../shared/bomba-navigation.service";
import { BombaApiService } from "../shared/bomba-api.service";
import { bombasModuleName, bombasAuditoriaModuleName } from "../shared/data.service";
import { NumberValidator } from "../../../shared/validators/number.validation";
import { Hidrometro } from "../shared/bomba.model";
import { UtilService } from "../../../shared/services/util.service";
import { abastecimentosModuleName } from "../../shared/data.service";

@Component({
    template: require('./bomba-auditoria-detail.component.html'),
    styles: [require('./bomba-auditoria-detail.component.css')]
})
export class BombaAuditoriaDetailComponent implements OnInit {
    detail: any = {};
    list: any[] = [];
    formObject: Hidrometro = new Hidrometro();
    loading: boolean = true;
    showDisabled: boolean = false;
    submitted: boolean = false;
    bombasModuleName: any = bombasModuleName;
    bombasAuditoriaModule: any = bombasAuditoriaModuleName;
    hidrometroVirtual: any;
    module: any = abastecimentosModuleName;

    fromT: FormGroup;
    hidrometro = new FormControl('', Validators.compose([Validators.required, NumberValidator.numberFormat]));
    data = new FormControl('', Validators.required);

    private bombaId: number;

    constructor(
        private _bombaNavigationService: BombaNavigationService,
        private _bombasApiService: BombaApiService,
        private _utilService: UtilService,
        private _route: ActivatedRoute,
        private _cdRef:ChangeDetectorRef,
        private _fb: FormBuilder
    ) {
        this.fromT = _fb.group({
            hidrometro: this.hidrometro,
            data: this.data
        });
    }

    ngOnInit() {
        this.bombaId = +this._route.snapshot.params['id'];
        this._utilService.disabledFutureDates('hidroData');

        this.getBomba();
        this.getHidrometroVirtual();
        this.initForm();
    }

    ngAfterViewChecked() {
        this._cdRef.detectChanges();    }


    clickAuditoriaList() {
        this._bombaNavigationService.goToAuditoriaList();
    }

    clickAuditar() {
        this._bombaNavigationService.goToAuditar(this.bombaId);
    }

    keyupSave($event: any) {
        if ($event.keyCode === 13) {
            this.clickSave();
        }
    }

    clickSave() {
        this.submitted = true;

        if (!this.hidrometro.valid) {
            return false;
        }

        let date: any = document.getElementById('hidroData');
        if (!date.value) {
            return false;
        }

        let object: Hidrometro = this._utilService.cloneObject(this.formObject);
        object.bombaId = this.bombaId;
        object.data = this._utilService.convertStringToDate(date.value);

        this.onAdd(object);
    }

    private onAdd(object: Hidrometro) {
        this._bombasApiService.onPostHidrometro(object, this.onDone);
    }

    private onEdit(object: Hidrometro) {
        object.hidrometro = this.formObject.hidrometro;
        this._bombasApiService.onPutHidrometro(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.initForm();
        } else {
            if (Response.error.name === 'hidrometroJaCadastradoNoDia') {
                this.swalRepeatDate(Response.error);
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }
    }.bind(this));

    private getBomba() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.detail = Response;
            }
        }.bind(this));

        this._bombasApiService.onGetById(this.bombaId, onDone);
    }

    private getHidrometros() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    Response[x].data = this._utilService.convertDateToString(Response[x].data);
                }
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._bombasApiService.onGetHidrometroByBomba(this.bombaId, onDone);
    }

    private getHidrometroVirtual() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.hidrometroVirtual = Response.hidrometroVirtual;
            }
        }.bind(this));

        this._bombasApiService.onGetHidrometroVirtual(this.bombaId, onDone);
    }

    private swalRepeatDate = (function (err: any) {
        const t = this;
        let hidroAtual = err.Hidrometro.hidrometro;
        swal({
                title: 'Registro encontrado nesta data.',
                text: 'Há um hidrômetro registrado com o valor de ' + hidroAtual + ' litros para esta data. Você deseja reescrever este valor?',
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, reescrever",
                cancelButtonText: "Cancelar",
                closeOnConfirm: false
            },function() {
                return t.onEdit(err.Hidrometro);
            }
        );
    }.bind(this));

    private initForm() {
        this.getHidrometros();
        this.formObject = new Hidrometro();
        this.formObject.data = this._utilService.convertDateToString(new Date());
        this.submitted = false;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bomba-auditoria-detail/bomba-auditoria-detail.component.ts
 **/